
import Swal from "sweetalert2";
import { config } from "../CommonUrl/CommonUrls";
export function ViewImage(fileName) {
  let url = config.url.FILE_DOWNLOAD_URL + fileName;
  const dataType = fileName.split(".")[1];
  if (dataType === "pdf") {
    showPDF(url)
   }
  else if (dataType === "text") {
    const newTab = window.open();
    newTab.document.body.innerHTML =
      `<embed src="${url}" width="100%" height="100%" ></embed>`;
  }
  else {
    const swalPopup = Swal.fire({
      html: `<img src="${url}" class="img-thumbnail" />`,
      width: '80%',
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        content: 'custom-modal-content',
      },
    });
    window.addEventListener('popstate', () => {
      swalPopup.close();
    });
  }
}
const showPDF = (imgg) => ConvertFileToBase64(imgg)
.then(base64Data => {
    const extractedData = base64Data.split(',')[1];
    const binaryData = atob(extractedData);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
})
.catch(error => {
    console.error('Error:', error);
});
async function ConvertFileToBase64(fileUrl) {
  const response = await fetch(fileUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}






// import React, { useState, useEffect } from "react";
// import Swal from "sweetalert2";
// import Cookies from "js-cookie";
// import { config } from "../CommonUrl/CommonUrls";

// export default function ViewImage({ fileName, onClose }) {
//     const [imageUrl, setImageUrl] = useState(null);
//     const token = Cookies.get("jwtToken");

//     const showPDF = (imgg) =>
//         ConvertFileToBase64(imgg)
//             .then((base64Data) => {
//                 const extractedData = base64Data.split(",")[1];
//                 const binaryData = atob(extractedData);
//                 const arrayBuffer = new ArrayBuffer(binaryData.length);
//                 const uint8Array = new Uint8Array(arrayBuffer);
//                 for (let i = 0; i < binaryData.length; i++) {
//                     uint8Array[i] = binaryData.charCodeAt(i);
//                 }
//                 const blob = new Blob([uint8Array], { type: "application/pdf" });
//                 const url = URL.createObjectURL(blob);
//                 const newWindow = window.open(url, "_blank");

//                 if (newWindow) {
//                     const interval = setInterval(() => {
//                         if (newWindow.closed) {
//                             clearInterval(interval);
//                             if (onClose) onClose();
//                         }
//                     }, 500);
//                 }
//             })
//             .catch((error) => {
//                 console.error("Error:", error);
//             });

//     async function ConvertFileToBase64(fileUrl) {
//         const response = await fetch(fileUrl);
//         const blob = await response.blob();
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result);
//             reader.onerror = reject;
//             reader.readAsDataURL(blob);
//         });
//     }

//     useEffect(() => {
//         const fetchImage = async () => {
//             try {
//                 const response = await fetch(
//                     `${config.url.FILE_DOWNLOAD_URL}${encodeURIComponent(fileName)}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                         },
//                     }
//                 );

//                 if (!response.ok) throw new Error("Failed to fetch image");

//                 const blob = await response.blob();
//                 const reader = new FileReader();
//                 reader.onloadend = () => {
//                     setImageUrl(reader.result);
//                 };
//                 reader.readAsDataURL(blob);
//             } catch (error) {
//                 console.error("Error loading image:", error);
//                 if (onClose) onClose();
//             }
//         };

//         fetchImage();
//     }, [fileName, token]);

//     useEffect(() => {
//         if (!imageUrl) return;

//         const dataType = fileName.split(".").pop().toLowerCase();

//         if (dataType === "pdf") {
//             showPDF(imageUrl); // Will call onClose inside
//         } else if (dataType === "text") {
//             const newTab = window.open();
//             newTab.document.body.innerHTML = `
//                 <embed src="${imageUrl}" width="100%" height="100%"></embed>
//             `;
//             if (newTab) {
//                 const interval = setInterval(() => {
//                     if (newTab.closed) {
//                         clearInterval(interval);
//                         if (onClose) onClose();
//                     }
//                 }, 500);
//             }
//         } else {
//             Swal.fire({
//                 html: `<img src="${imageUrl}" class="img-thumbnail" />`,
//                 width: "80%",
//                 showCloseButton: true,
//                 showConfirmButton: false,
//                 customClass: {
//                     content: "custom-modal-content",
//                 },
//             }).then(() => {
//                 if (onClose) onClose();
//             });

//             window.addEventListener("popstate", () => {
//                 Swal.close();
//                 if (onClose) onClose();
//             });
//         }
//     }, [imageUrl, fileName]);

//     return null;
// }
